export default __webpack_public_path__ + "static/media/snapbg.fb6d2cfc.png";